import { TimeRangePreset } from '../types/dashboard';

const ALL_TIME_START = new Date('2024-01-01T00:00:00.000Z');

const startOfDay = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

const endOfDay = (date: Date) => {
  const value = startOfDay(date);
  value.setDate(value.getDate() + 1);
  return value;
};

const startOfWeekSun = (date: Date) => {
  const value = startOfDay(date);
  const day = value.getDay();
  value.setDate(value.getDate() - day);
  return value;
};

const startOfMonth = (date: Date) => new Date(date.getFullYear(), date.getMonth(), 1);
const startOfYear = (date: Date) => new Date(date.getFullYear(), 0, 1);

export const buildTimeRange = (
  preset: TimeRangePreset,
  customStart?: string,
  customEnd?: string
): { startAt: Date; endAt: Date } => {
  const now = new Date();

  switch (preset) {
    case 'live':
      return {
        startAt: new Date(now.getTime() - 60 * 60 * 1000),
        endAt: now,
      };
    case 'last_24_hours':
      return { startAt: new Date(now.getTime() - 24 * 60 * 60 * 1000), endAt: now };
    case 'today':
      return { startAt: startOfDay(now), endAt: now };
    case 'yesterday': {
      const yesterday = new Date(now);
      yesterday.setDate(yesterday.getDate() - 1);
      return { startAt: startOfDay(yesterday), endAt: endOfDay(yesterday) };
    }
    case 'this_week':
      return { startAt: startOfWeekSun(now), endAt: now };
    case 'last_7_days':
      return { startAt: new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000), endAt: now };
    case 'this_month':
      return { startAt: startOfMonth(now), endAt: now };
    case 'last_30_days':
      return { startAt: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000), endAt: now };
    case 'this_year':
      return { startAt: startOfYear(now), endAt: now };
    case 'last_365_days':
      return { startAt: new Date(now.getTime() - 365 * 24 * 60 * 60 * 1000), endAt: now };
    case 'all_time':
      return { startAt: ALL_TIME_START, endAt: now };
    case 'custom': {
      if (!customStart || !customEnd) {
        return { startAt: new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000), endAt: now };
      }
      const customStartDate = new Date(`${customStart}T00:00:00`);
      const customEndDate = new Date(`${customEnd}T23:59:59`);
      return { startAt: customStartDate, endAt: customEndDate };
    }
    default:
      return { startAt: new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000), endAt: now };
  }
};

export const formatRangeLabel = (startAtIso: string, endAtIso: string) => {
  const start = new Date(startAtIso);
  const end = new Date(endAtIso);
  return `${start.toLocaleDateString()} - ${end.toLocaleDateString()}`;
};
